import { useState } from 'react';
import { X, Loader2, ArrowRight, ShieldCheck } from 'lucide-react';
import { offers } from '../mock';
import './PaymentModal.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const OFFER_TO_LOOKUP = {
  vitrine: 'vitrine_deposit_40',
  siteweb: 'siteweb_deposit_40',
};

const PaymentModal = ({ open, offerId, onClose }) => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', notes: '' });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  if (!open) return null;

  const offer = offers.find((o) => o.id === offerId);
  const lookupKey = OFFER_TO_LOOKUP[offerId];
  const depositAmount = offer ? Math.round(offer.price * 0.4) : 0;

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setError('');
    setSubmitting(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/payments/checkout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          lookup_key: lookupKey,
          origin_url: window.location.origin,
          customer_name: form.name,
          customer_email: form.email,
          customer_phone: form.phone,
          notes: form.notes,
        }),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      if (data.checkout_url) {
        window.location.href = data.checkout_url;
      } else {
        throw new Error('Aucune URL de paiement reçue.');
      }
    } catch (err) {
      setError("Une erreur est survenue. Réessayez ou contactez Nolan au 06 69 47 75 36.");
      setSubmitting(false);
    }
  };

  if (!offer) return null;

  return (
    <div className="payment-modal-backdrop" onClick={onClose}>
      <div className="payment-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <button className="payment-modal-close" onClick={onClose} aria-label="Fermer">
          <X size={20} />
        </button>

        <div className="payment-modal-header">
          <span className="payment-eyebrow">
            <ShieldCheck size={14} /> Paiement sécurisé Stripe
          </span>
          <h3 className="payment-modal-title">{offer.name}</h3>
          <p className="payment-modal-subtitle">Acompte 40% pour démarrer</p>

          <div className="payment-summary">
            <div className="payment-summary-row">
              <span>Prix total du projet</span>
              <span>{offer.price} €</span>
            </div>
            <div className="payment-summary-row highlight">
              <span>Acompte à payer maintenant (40%)</span>
              <span className="amount">{depositAmount} €</span>
            </div>
            <div className="payment-summary-row muted">
              <span>Solde à la livraison</span>
              <span>{offer.price - depositAmount} €</span>
            </div>
          </div>
        </div>

        <form className="payment-form" onSubmit={handleSubmit}>
          <div className="pf-row">
            <div className="pf-field">
              <label htmlFor="pf-name">Nom complet</label>
              <input required id="pf-name" name="name" value={form.name} onChange={handleChange} placeholder="Jean Dupont" />
            </div>
            <div className="pf-field">
              <label htmlFor="pf-email">Email</label>
              <input required type="email" id="pf-email" name="email" value={form.email} onChange={handleChange} placeholder="vous@commerce.fr" />
            </div>
          </div>
          <div className="pf-field">
            <label htmlFor="pf-phone">Téléphone (optionnel)</label>
            <input id="pf-phone" name="phone" value={form.phone} onChange={handleChange} placeholder="06 12 34 56 78" />
          </div>
          <div className="pf-field">
            <label htmlFor="pf-notes">Précisions sur votre projet (optionnel)</label>
            <textarea id="pf-notes" name="notes" value={form.notes} onChange={handleChange} placeholder="Type de commerce, objectif, délai souhaité..." rows={3} />
          </div>

          {error && <div className="pf-error">{error}</div>}

          <button type="submit" className="pf-submit" disabled={submitting}>
            {submitting ? <><Loader2 size={18} className="spin" /> Redirection...</> : <>Payer {depositAmount} € <ArrowRight size={18} /></>}
          </button>

          <p className="pf-legal">
            Paiement traité par Stripe en mode test. Aucun débit réel ne sera effectué. Utilisez la carte de test <strong>4242 4242 4242 4242</strong>, une date future et n'importe quel CVC.
          </p>
        </form>
      </div>
    </div>
  );
};

export default PaymentModal;
